(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll(
      '.b2b-section__header, .b2b-intro__grid, .b2b-stat, .b2b-market-fit article, .b2b-product-card, .b2b-products-support, .b2b-advantage, .b2b-process-list li, .b2b-cert-badge, .b2b-factory__media, .b2b-factory__content, .b2b-trade-list article, .b2b-contact__details, .b2b-quote-panel'
    );

    revealTargets.forEach(function (item, index) {
      item.setAttribute('data-b2b-animate', '');
      item.style.setProperty('--b2b-delay', (index % 6) * 70 + 'ms');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );

    revealTargets.forEach(function (item) {
      observer.observe(item);
    });

    var heroMedia = document.querySelector('.b2b-hero__media');
    var sections = document.querySelectorAll('.b2b-section');
    var processList = document.querySelector('.b2b-process-list');
    var depthElements = document.querySelectorAll('[data-b2b-depth]');
    var progressBar = document.querySelector('.b2b-scroll-progress span');
    var ticking = false;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function updateScrollEffects() {
      var scrollTop = window.scrollY || window.pageYOffset;
      var maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      var pageProgress = clamp(scrollTop / maxScroll, 0, 1);

      document.documentElement.style.setProperty('--b2b-scroll-progress', pageProgress.toFixed(4));

      if (progressBar) {
        progressBar.style.transform = 'scaleX(' + pageProgress + ')';
      }

      if (heroMedia) {
        var heroOffset = Math.min(scrollTop * 0.09, 70);
        heroMedia.style.transform = 'translate3d(0,' + heroOffset + 'px,0) scale(1.05)';
      }

      sections.forEach(function (section) {
        var rect = section.getBoundingClientRect();
        var sectionProgress = clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0, 1);
        section.style.setProperty('--b2b-section-progress', sectionProgress.toFixed(4));
      });

      if (processList) {
        var processRect = processList.getBoundingClientRect();
        var processProgress = clamp((window.innerHeight * 0.78 - processRect.top) / Math.max(processRect.height, 1), 0, 1);
        processList.style.setProperty('--b2b-process-progress', processProgress.toFixed(4));
      }

      depthElements.forEach(function (item) {
        var depth = parseFloat(item.getAttribute('data-b2b-depth') || '0');
        var parentSection = item.closest('.b2b-section');
        var parentProgress = parentSection ? parseFloat(parentSection.style.getPropertyValue('--b2b-section-progress') || '0.5') : 0.5;
        item.style.setProperty('--b2b-depth-y', ((parentProgress - 0.5) * depth * 120).toFixed(2) + 'px');
      });

      ticking = false;
    }

    function requestScrollEffects() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollEffects);
        ticking = true;
      }
    }

    updateScrollEffects();
    window.addEventListener('scroll', requestScrollEffects, { passive: true });
    window.addEventListener('resize', requestScrollEffects);

    var statObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target.dataset.counted === 'true') {
          return;
        }

        var target = entry.target;
        var original = target.textContent.trim();
        var numeric = parseFloat(original.replace(/[^0-9.]/g, ''));

        if (!numeric) {
          return;
        }

        target.dataset.counted = 'true';
        var suffix = original.replace(/[0-9.,]/g, '');
        var start = performance.now();
        var duration = 1100;

        function tick(now) {
          var progress = clamp((now - start) / duration, 0, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(numeric * eased);
          target.textContent = value + suffix;

          if (progress < 1) {
            window.requestAnimationFrame(tick);
          } else {
            target.textContent = original;
          }
        }

        window.requestAnimationFrame(tick);
        statObserver.unobserve(target);
      });
    }, { threshold: 0.6 });

    document.querySelectorAll('.b2b-stat strong').forEach(function (item) {
      statObserver.observe(item);
    });

    var countupObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target.dataset.counted === 'true') {
          return;
        }

        var target = entry.target;
        var startValue = parseFloat(target.getAttribute('data-b2b-count-start') || '0');
        var end = parseFloat(target.getAttribute('data-b2b-count-end') || '0');

        if (!end) {
          return;
        }

        var prefix = target.getAttribute('data-b2b-count-prefix') || '';
        var suffix = target.getAttribute('data-b2b-count-suffix') || '';
        var finalText = target.getAttribute('data-b2b-count-final');
        var start = performance.now();
        var duration = 950;

        target.dataset.counted = 'true';

        function tickCount(now) {
          var progress = clamp((now - start) / duration, 0, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(startValue + (end - startValue) * eased);

          target.textContent = prefix + value + suffix;

          if (progress < 1) {
            window.requestAnimationFrame(tickCount);
          } else {
            target.textContent = finalText || prefix + end + suffix;
          }
        }

        window.requestAnimationFrame(tickCount);
        countupObserver.unobserve(target);
      });
    }, { threshold: 0.6 });

    document.querySelectorAll('[data-b2b-countup]').forEach(function (item) {
      countupObserver.observe(item);
    });

    document.querySelectorAll('.b2b-product-card').forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;

        card.style.setProperty('--b2b-card-tilt-x', (-y * 4).toFixed(2) + 'deg');
        card.style.setProperty('--b2b-card-tilt-y', (x * 4).toFixed(2) + 'deg');
      });

      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--b2b-card-tilt-x', '0deg');
        card.style.setProperty('--b2b-card-tilt-y', '0deg');
      });
    });
  }

  var filterButtons = document.querySelectorAll('[data-b2b-filter-trigger]');
  var productCards = document.querySelectorAll('[data-b2b-filter]');
  var filterStatus = document.querySelector('[data-b2b-filter-status]');

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var activeFilter = button.getAttribute('data-b2b-filter-trigger');
      var visibleCount = 0;

      filterButtons.forEach(function (item) {
        var isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      productCards.forEach(function (card) {
        var shouldShow = activeFilter === 'all' || card.getAttribute('data-b2b-filter') === activeFilter;
        card.classList.toggle('is-hidden', !shouldShow);
        if (shouldShow) {
          visibleCount += 1;
        }
      });

      if (filterStatus) {
        filterStatus.textContent =
          activeFilter === 'all'
            ? 'Showing all product categories.'
            : 'Showing ' + visibleCount + ' ' + activeFilter + ' product categories.';
      }
    });
  });

  var sectionNav = document.querySelector('[data-b2b-section-nav]');

  if (sectionNav) {
    var sectionLinks = Array.prototype.slice.call(sectionNav.querySelectorAll('[data-b2b-section-link]'));
    var sectionTargets = sectionLinks
      .map(function (link) {
        var target = document.querySelector(link.getAttribute('href'));
        return target ? { link: link, target: target } : null;
      })
      .filter(Boolean);

    function setActiveSectionNav(activeId) {
      sectionTargets.forEach(function (item) {
        item.link.classList.toggle('is-active', item.target.id === activeId);
      });
    }

    function focusSectionTarget(target) {
      var hadTabindex = target.hasAttribute('tabindex');
      var previousTabindex = target.getAttribute('tabindex');

      if (!hadTabindex) {
        target.setAttribute('tabindex', '-1');
      }

      target.focus({ preventScroll: true });

      if (!hadTabindex) {
        target.addEventListener(
          'blur',
          function () {
            target.removeAttribute('tabindex');
          },
          { once: true }
        );
      } else if (previousTabindex !== null) {
        target.setAttribute('tabindex', previousTabindex);
      }
    }

    sectionLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        var target = document.querySelector(href);

        if (!target) {
          return;
        }

        event.preventDefault();
        setActiveSectionNav(href.replace('#', ''));
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        focusSectionTarget(target);
      });
    });

    if ('IntersectionObserver' in window && sectionTargets.length) {
      var navObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActiveSectionNav(entry.target.id);
            }
          });
        },
        { threshold: 0.18, rootMargin: '-34% 0px -48% 0px' }
      );

      sectionTargets.forEach(function (item) {
        navObserver.observe(item.target);
      });
    }

    if (sectionTargets[0]) {
      setActiveSectionNav(sectionTargets[0].target.id);
    }
  }
})();
